<template>
  <div class="auditDetails">
    <head-panel title="财务管理" subtitle="FINANCIAL MANAGEMENT" :exportExc="false"></head-panel>
    <div class="formPanel">
      <h3 class="subTit">{{currentTitle}}</h3>
      <el-form :model="form" ref="form" class="ruleForm" :rules="rules" label-width="12%">
        <h4 class="form-title">广告主/代理商信息</h4>
        <el-form-item label="广告主/代理商名称">
          <el-input v-model="form.adverName" class="input_sm" disabled></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="form.type" class="input_sm" disabled></el-input>
        </el-form-item>
        <el-form-item label="对公银行名称">
          <!--<el-input v-model="form.bankName" class="input_sm" disabled></el-input>-->
          <ny-select
            :data="financial.bankMenu"
            v-model="form.bankName"
            :keyValue="['value', 'name']"
            @change="changeSelect"
            type="bankName"
            placeholder="请选择"
            class="advertiseSelect input_sm"
            disabled
          ></ny-select>
        </el-form-item>
        <el-form-item label="对公银行账号">
          <el-input v-model="form.bankNum" class="input_sm" disabled></el-input>
        </el-form-item>
        <el-form-item label="对公开户支行">
          <el-input v-model="form.bankSub" class="input_lg" disabled></el-input>
        </el-form-item>
        <el-form-item label="录入到款金额">
          <el-input v-model.number="form.money" class="input_sm" disabled></el-input>
        </el-form-item>
        <h4 class="form-title">返货设置</h4>
        <el-form-item label="时间周期">
          <ny-select
            :data="financial.timePeriodMenu"
            v-model="form.timePeriod"
            :keyValue="['value', 'name']"
            @change="changeSelect"
            type="timePeriod"
            placeholder="请选择"
            class="advertiseSelect input_sm"
          ></ny-select>
        </el-form-item>
        <el-form-item label="消费额" class="consume">
          <el-col>
            <el-button type="primary" @click="handleCreate" class="mr20">+</el-button>
            <label>添加消费额阶段</label>
          </el-col>
          <el-col class="ml16">
            <el-form-item prop="consume">
              <el-col v-for="(item, index) in form.consume" :key="item.money">
                <el-input
                  v-model="item.rank"
                  class="input_sm"
                  @input.native="changeComdify('form' ,'consume', index)"
                ></el-input>
                <label class="consume_title">元</label>
                <label class="consume_title">返货:</label>
                <el-input v-model.number="item.rate" class="input_sm"></el-input>
                <label class="consume_title">%</label>
              </el-col>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item class="btnGroups">
          <el-button type="primary" class="commit" @click="submitForm('form')">提交</el-button>
          <el-button type="primary" class="cancel" @click="cancel('form')">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { headPanel, NySelect } from '@/global/components';
import { post } from '../../http/index'
import { mapGetters } from 'vuex';
import { comdify, delcommafy } from '@/global/util/util'
export default {
  data () {
    var validatorRank = (rule, value, callback) => {
      let reg = /^([0-9]{1,}([.][0-9]{2})?)$/
      this.form.consume.every((res) => {
        if (res.rank === '' || res.rate === '') {
          callback(new Error('消费额信息填写完整'));
        } else {
          if (!reg.test(res.rate)) {
            callback(new Error('返点请输入数字或精确到小数点后两位'));
          } else if (delcommafy(res.rank) > 100000000000) {
            callback(new Error('输入消费额不得超过1000亿'));
          } else if (res.rate > 100) {
            callback(new Error('返点百分比不得超过100'));
          } else {
            callback()
          }
        }
      })
    }
    return {
      currentTitle: '返货设置',
      rankShow: true,
      form: {
        adverName: '',
        type: '',
        bankName: '',
        bankNum: '',
        bankSub: '',
        money: '',
        timePeriod: '',
        consume: [
          { rank: '', rate: '' }
        ]
      },
      rules: {
        consume: [
          { validator: validatorRank, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      financial: 'finance/financial',
      userid: 'login/userid'
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$store.dispatch('finance/getTimePeriod')
      this.$store.dispatch('finance/getBankMenu')
      post('/admin/finance/editinfo', { id: this.$route.params.id }).then(res => {
        if (res.code === 1) {
          let data = res.data
          this.form.adverName = data.top.username
          this.form.type = data.top.user_type
          this.form.bankName = data.top.bank
          this.form.bankNum = data.top.account
          this.form.bankSub = data.top.bank_addr
          this.form.money = data.top.balance
          if (Object.keys(data.bottom).length > 0) {
            this.form.timePeriod = data.bottom.type + ''
            this.form.consume = data.bottom.rule
            this.form.consume.forEach((res) => {
              res.rank = comdify(res.rank)
            })
          }
        }
      })
    },
    changeSelect (val) {
    },
    changeComdify (form, name, index) {
      this.$nextTick(() => {
        if (this[form][name][index].rank !== null) {
          this[form][name][index].rank = comdify(delcommafy(this[form][name][index].rank))
        }
      })
    },
    handleCreate () {
      let boolean = this.form.consume.every((res) => {
        if (res.rank === '' || res.rate === '') {
          this.$message('消费额信息请填写完整在添加')
          return false
        } else {
          return true
        }
      })
      if (!boolean) return false
      let data = { rank: '', rate: '' }
      this.form.consume.push(data)
    },
    submitForm (formName) {
      let self = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {}
          this.form.consume.forEach((res) => {
            res.rank = delcommafy(res.rank)
          })
          params.id = self.$route.params.id
          params.type = self.form.timePeriod
          params.account_id = self.userid
          params.rule = JSON.stringify(self.form.consume)
          post('/admin/finance/rebate', params).then(res => {
            if (res.code === 1) {
              self.$message('设置成功')
              self.$router.push({ name: 'editFinancial' });
            } else {
              self.$message.error(res.msg)
            }
          })
        }
      });
    },
    cancel (formName) {
      this.$refs[formName].resetFields();
      this.$router.push({ name: 'editFinancial' });
    }
  },
  components: {
    headPanel,
    NySelect
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.auditDetails {
  .ruleForm {
    .input_sm {
      width: 210px;
    }
    .input_lg {
      width: 350px;
    }
    .ml16 {
      margin-left: 16px;
    }
    .mr20 {
      margin-right: 20px;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
    .btnGroups {
      text-align: left;
      margin-left: 16px;
    }
  }
  .upload-img {
    width: 200px;
    height: 200px;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .form-title {
    margin-left: 20px;
    font-size: 18px;
    margin-bottom: 10px;
  }
  .consume_title {
    margin: 0 20px;
  }
  .consume {
    .el-col {
      float: none;
      margin-bottom: 22px;
    }
  }
}
</style>
